export default __webpack_public_path__ + "static/media/ep9.08ff0bee.jpeg";